import {ContactPageDynamic} from "../src/pages/contact/ContactPageDynamic";
import {prepareHydratedApp} from "./utils/prepare_hydrate_app";

const config = [{reactDynamic: "contactpage", view: <ContactPageDynamic />}];

(() => prepareHydratedApp(config))();
